const POSE_IMAGES = {
  principal: '/images/brand/bruno-principal.png',
  acenando: '/images/brand/bruno-acenando.png',
  tablet: '/images/brand/bruno-tablet.png',
  lupa: '/images/brand/bruno-lupa.png',
  calculadora: '/images/brand/bruno-calculadora.png',
  handshake: '/images/brand/bruno-handshake.png',
};

const TYPE_STYLES = {
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  success: 'bg-green-50 border-green-200 text-green-800',
  tip: 'bg-orca-50 border-orca-200 text-navy',
};

function BrunoMessage({ pose, variant, message, type = 'info', size = 'md', children }) {
  const resolvedPose = pose || variant || 'principal';
  const imgSize = size === 'sm' ? 'w-10 h-10' : size === 'lg' ? 'w-16 h-16' : 'w-12 h-12';
  const styles = TYPE_STYLES[type] || TYPE_STYLES.info;

  return (
    <div className={`flex items-start gap-3 rounded-xl border p-4 ${styles}`}>
      <img
        src={POSE_IMAGES[resolvedPose] || POSE_IMAGES.principal}
        alt="Bruno"
        className={`${imgSize} rounded-full object-cover flex-shrink-0`}
      />
      <div className="flex-1 min-w-0">
        {children || <p className="text-sm font-medium leading-relaxed">{message}</p>}
      </div>
    </div>
  );
}

export default BrunoMessage;
